import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

/* The in-progress spinner is transient per-client UI state held in React,
 * never a document attribute, so there is deliberately no `loading` attr. */
export const SignatureButtonNode = inlineAtomNode(
  'signature-button',
  'button',
  {
    signature: { dataAttr: 'data-signature' },
    display: { isDisplay: true },
  }
)
